// packages
import cx from 'classnames';
import { Component, h } from 'preact';

import { get_directory_slug } from '../election-utils';

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  notes: { [key: string]: any };
  tableHeader: JSX.Element;
  contestTitle: string;
  contestOffice: string;
  renderCandidate: any;
  visibleCandidatesCount?: number;
};

class EmptyTable extends Component<Props> {
  constructor() {
    super();

    this.state = {

    };
  }

  render() {
    const {
      contestTitle,
      contestNum,
      tableHeader,
      slug,
    } = this.props;



    let seatClass = cx('seat', {
        'add_bottom_margin': slug == 'texas-house' || slug == 'state-board-of-education',
      })
    

    let directory_slug;

    if (contestNum) {
      directory_slug = get_directory_slug(contestTitle);
    }


    return (
      <div class={seatClass}>
        <h3 class="seat__title balance-text"><span>{contestTitle} {contestNum}
        </span>
                {directory_slug[0] != null && (
              <a class="t-links-unset"
                href={`https://www.texastribune.org/directory/districts/${directory_slug[0]['directory-slug']}/${contestNum}`}
              >
                <span class="icon-div" title="Click to learn more about this district">
                  <svg class="icon icon-info">
                    <use xlinkHref="#icon-info"></use>
                  </svg>
                </span>
              </a>
            )}
        </h3>
        <div class="seat__race no_election__wrapper">
        <table class="race__candidates"> {tableHeader} </table>
        <div class="no_election">Seat is not up for election this year.</div>
        </div>
      </div>
    );
  }
}

EmptyTable.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
  visibleCandidatesCount: 3,
};

export default EmptyTable;